import React from 'react';

function Interests() {
    return (
        <div className='left-column-container'>
            <div className='left-column-title'>
                <h2 className='whitetext12'>Josh's Interests</h2>
            </div>
            <div className='interests-container'>
                <div className='interest'>
                       <h3 className='lightbluetext8'>General</h3>
                       <p> Books, music, food, cycling, being a dad, fighting games,
                           learning new things</p> 
                </div>
                <div className='interest'>
                       <h3 className='lightbluetext8'>Music</h3>
                       <p>	Modest Mouse, Say Anything, Born Ruffians, Das Racist, 
                           Injury Reserve, Radiohead, Charles Mingus, 
                           Algernon Cadwallader, Beach House, Grizzly Bear,
                           Snowing, Jon Brion</p> 
                </div>
                <div className='interest'>
                       <h3 className='lightbluetext8'>Movies</h3>
                       <p>	Punch-Drunk Love, Her, The Shining, No Coutry for Old Men,
                           Fargo, Eternal Sunshine</p> 
                </div>
                <div className='interest'>
                       <h3 className='lightbluetext8'>Television</h3>
                       <p>	X-Files, Twin Peaks, DS9, TNG, King of the Hill,
                           Adventure Time</p> 
                </div>
                <div className='interest'>
                       <h3 className='lightbluetext8'>Books</h3>
                       <p>	Anything by Vonnegut, The Stranger, Notes From Underground,
                           American Psycho, What We Talk About When We Talk About Love</p> 
                </div>
            </div>
        </div>
    )
}

export default Interests;